// extracted by mini-css-extract-plugin
module.exports = {"notification":"UserNotifications_notification__1m7yp","notificationNew":"UserNotifications_notificationNew__26UW_","notificationType":"UserNotifications_notificationType__27YXm"};